import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wave", "text", "measure"]

  connect() {
    this.copy = this.textTarget.textContent

    // fit() rewrites the viewBox, so keep the original canvas size
    const { width, height } = this.element.viewBox.baseVal
    this.canvas = { width, height }

    this.resizeObserver = new ResizeObserver(() => {
      this.fit()
      this.fill()
    })

    this.resizeObserver.observe(this.element)

    this.measure()

    // Fonts change the text width, so measure again once they load.
    document.fonts.ready.then(() => this.measure())

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.frame = requestAnimationFrame((time) => this.scroll(time))
    }
  }

  disconnect() {
    this.resizeObserver.disconnect()
    cancelAnimationFrame(this.frame)
  }

  fit() {
    const width = this.element.clientWidth
    const height = this.element.clientHeight
    if (!width || !height) return

    const scaleX = width / this.canvas.width
    const scaleY = height / this.canvas.height

    this.element.setAttribute("viewBox", `0 0 ${width} ${height}`)

    this.element.querySelectorAll("path[data-d]").forEach((path) => {
      let index = 0

      const d = path.dataset.d.replace(
        /-?\d+(\.\d+)?/g,
        (n) => (n * (index++ % 2 ? scaleY : scaleX)).toFixed(1)
      )

      path.setAttribute("d", d)
    })
  }

  measure() {
    const start = (index) => this.measureTarget.getStartPositionOfChar(index).x
    this.loop = start(this.copy.length) - start(0)
    this.fill()
  }

  fill() {
    if (!this.loop) return

    const copies = Math.ceil(this.waveTarget.getTotalLength() / this.loop) + 2
    const text = this.copy.repeat(copies)
    if (this.textTarget.textContent !== text) this.textTarget.textContent = text
  }

  scroll(time) {
    this.start ??= time

    if (this.loop) {
      this.textTarget.setAttribute("startOffset", `${-(((time - this.start) * 0.025) % this.loop)}px`)
    }

    this.frame = requestAnimationFrame((time) => this.scroll(time))
  }
}
